import type { HeadersFunction, LoaderFunction } from '@remix-run/node';
import { json, redirect } from '@remix-run/node';

import useTypedLoaderData from '~/hooks/useUtils/useTypedLoaderData';
import remixI18n from '~/i18next.server';
import type { Publication } from '~/interfaces/publication';
import getPublication from '~/services/api/publication/getPublication.server';
import { loaderSession } from '~/session';
import setCacheHeaders from '~/utils/setCacheHeaders/index.server';

export const headers: HeadersFunction = ({ loaderHeaders }) => {
  return {
    'cache-control': loaderHeaders.get('cache-control') || 'max-age=0', // no-cache
    'Cache-Tag': 'orchid-page',
  };
};

export const loader: LoaderFunction = async ({ request }) => {
  const { session } = await loaderSession(request);

  const url = new URL(request.url);
  const publication = await getPublication(request, session);
  const t = await remixI18n.getFixedT(publication?.language || 'en', 'common');

  if (!publication?.terms_of_service || publication?.terms_of_service?.length === 0) {
    return redirect('/');
  }

  return json(
    {
      publication,
      requestUrl: url.href,
      metaTitle: t('meta.titles.tos'),
    },
    {
      headers: setCacheHeaders({
        maxAge: 0,
        sMaxAge: 60 * 60 * 24 * 30,
        staleWhileRevalidate: 60,
      }),
    },
  );
};

interface ToSLoaderData {
  publication: Publication;
  requestUrl: string;
  metaTitle: string;
}

const ToS = () => {
  const { publication } = useTypedLoaderData<ToSLoaderData>();

  return (
    <div className="flex flex-col items-center justify-center pb-14 pt-8">
      <h1 className="text-3xl font-bold text-gray-900 md:text-5xl">Terms of Service</h1>
      <p className="relative mx-auto mt-6 w-full max-w-6xl px-0 sm:px-4">{publication?.terms_of_service}</p>
    </div>
  );
};

export default ToS;
